import { Container, Row, Col, Button, Fade } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import '../components/GlobalStyle.css';
import '../components/Backgrounds/Backgrounds.css';

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import RebateSplash from '../assets/images/Rebates - Splash.png';
import CircleIcon3 from '../assets/icons/BPS Icon - Circle 3.png';
import CircleIcon1 from '../assets/icons/BPS Icon - Circle 1.png';
import CircleIcon2 from '../assets/icons/BPS Icon - Circle 2.png';
import TrainingIcon from '../assets/icons/BPS Icon - Training.png';
import CustomerServiceIcon from '../assets/icons/BPS Icon - Customer Service.png';
import MonitorPhoneIcon from '../assets/icons/BPS Icon - Monitor + Phone.png';
import CheckCirclesIcon from '../assets/icons/BPS Icon - Check Circles.png';
import RocketIcon from '../assets/icons/BPS Icon - Rocket.png';


import { FadeLoad, FadeScroll } from '../components/styled/Motion.styled';
import { RebateAccordion } from '../components/RebateComponents/RebateAccordions';



const Rebates = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Rebates</title>
                <link rel="canonical" href="https://bestpayment.solutions/rebates" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 circle-bg-3-scroll'>
                <FadeLoad>
                    <Row className='align-items-center justify-content-evenly py-5 text-center text-lg-start'>
                        <Col lg={5} md={6} sm={10}>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Rebate Automater</h2>
                            <h1 className='fs-60'>
                                We make rebates quick, easy, and effective
                            </h1>
                        </Col>
                        <Col lg={5} md={6}>
                            <img src={RebateSplash} width='90%' />
                        </Col>
                    </Row>
                </FadeLoad>
            </Container>
            <Container fluid className='vh-75 text-center py-5 bg-cream'>
                <Row className="justify-content-evenly pt-4">
                    <Col xs={12}>
                        <h3 className='fs-48'>Rebates bring results</h3>
                    </Col>
                    <Col lg={3} sm className='pt-4'>
                        <img src={CircleIcon3} width={60} />
                        <h5 className='fw-bold pt-4'>Optimize your conversion rates</h5>
                        <p>
                            Rebates act as your sales superpower: guiding consumer choices and motivating them to complete their purchase.
                        </p>
                    </Col>
                    <Col lg={3} sm className='pt-4'>
                        <img src={CircleIcon1} width={60} />
                        <h5 className='fw-bold pt-4'>Build enduring brand loyalty</h5>
                        <p>
                            Leverage rebates to establish a lasting, favorable brand impression. This will have consumers not only coming back for more but also advocating for your brand.
                        </p>
                    </Col>
                    <Col lg={3} sm className='pt-4'>
                        <img src={CircleIcon2} width={60} />
                        <h5 className='fw-bold pt-4'>Launch Brand Expansion</h5>
                        <p>
                            Rebates work like a magnet, pulling in eager new customers, ready to explore your brand’s offerings.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='text-center py-5 circle-bg-4-scroll'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center py-5">
                        <Col lg={6} className='pt-4'>
                            <p className='fs-24 fw-bold color-sky-tint-1'>Use cases</p>
                            <h3 className='fs-48'>Are you ready to unlock the power of rebates?</h3>
                            <p>
                                Rebates are powerful tools that resonate with customers, making them feel valued and rewarded. Offering rebates not only increases sales but fosters customer loyalty.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly py-2">
                    <Col lg={3} className='py-3'>
                        <h4>Increase sales & conversion rates</h4>
                        <p>
                            In today's competitive market, standing out is crucial. Transform interest into action and maximize conversions. With exciting incentives, like Prepaid Visa Rewards Cards, rebates provide that extra push for undecided customers.
                        </p>
                    </Col>
                    <Col lg={3} className='py-3'>
                        <h4>Warranty & product registration</h4>
                        <p>
                            Associating rebates with product registration encourages more customers to engage by enhancing product value and promoting brand interaction. It's a win-win for both businesses and consumers.
                        </p>
                    </Col>
                    <Col lg={3} className='py-3'>
                        <h4>Recalls & satisfaction payments</h4>
                        <p>
                            Negative experiences can become opportunities to demonstrate your commitment to your customers. By pairing proactive and transparent recall practices with a rebate payment in a convenient and flexible form, like a Prepaid Visa Rewards Card, you demonstrate commitment to customer satisfaction. This reinforces brand trust and turns challenges into brand-strengthening moments.
                        </p>
                    </Col>
                </Row>
            </Container>

            <Container fluid className='text-center py-5'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center py-5">
                        <Col>
                            <h3 className='fs-48'>Key features of our Rebate Automater</h3>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly">
                    <Col lg={3} sm={6} className='py-3'>
                        <img src={RocketIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Fast setup</h4>
                        <p>
                            Launch your program in record time. With our streamlined processes, you can have your fully customized rebate program up and running in less than 90 days. Capture market momentum and stay ahead of the competition.
                        </p>
                    </Col>
                    <Col lg={3} sm={6} className='py-3'>
                        <img src={CheckCirclesIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Versatile incentive options</h4>
                        <p>
                            Choose from our diverse range of incentives and payment options. Whether you prefer physical or virtual Visa Rewards Cards, ACH, or checks, you can pick the solution that’s right for your program.
                        </p>
                    </Col>
                    <Col lg={3} sm={8} className='py-3'>
                        <img src={MonitorPhoneIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Accessibility & ease-of-use</h4>
                        <p>
                            Our intuitive platforms ensure user satisfaction, leading to higher engagement and participation rates. Enjoy cross-device compatibility. Users can access rebates whenever and wherever, increasing participation and satisfaction.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly">
                    <Col lg={3} sm={6} className='py-3'>
                        <img src={CustomerServiceIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Comprehensive support</h4>
                        <p>
                            Our world-class customer and technical support teams ensure your program runs seamlessly. Enjoy a smooth experience for both you and your customers. From setup to daily operations, we're here to answer questions and resolve challenges.
                        </p>
                    </Col>
                    <Col lg={3} sm={6} className='py-3'>
                        <img src={TrainingIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Empowering team training</h4>
                        <p>
                            Knowledge is the key to success. Our comprehensive training modules equip your team with all the necessary insights and tools. This allows them to navigate the rebate program with confidence and efficiency.
                        </p>
                    </Col>
                </Row>
            </Container>

            <Container fluid className='py-5'>
                <FadeScroll>
                    <Row className="py-5">
                        <Col>
                            <h3 className='fs-48 text-center'>Tools that drive rebate program success</h3>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className='justify-content-center pb-5'>
                    <Col lg={10}>
                        <RebateAccordion />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default Rebates;